"use client";

import { twMerge } from "tailwind-merge";

import { useUpdateQuery } from "@/hooks/use-update-query";

import { TrendFactor, trendFactors } from "../data/factors";

type Props = {
  currentFactor?: TrendFactor;
};

export const TrendFactorTabs = ({ currentFactor = "power" }: Props) => {
  const { updateQuery } = useUpdateQuery();
  return (
    <nav
      className="isolate flex h-10 w-full divide-x divide-gray-200 rounded-lg shadow @sm:hidden"
      aria-label="Tabs"
    >
      {trendFactors.map((factor, tabIdx) => {
        const isActive = currentFactor === factor.id;
        return (
          <button
            key={factor.id}
            className={twMerge(
              "group relative min-w-0 flex-1 overflow-hidden whitespace-nowrap bg-white text-center text-sm font-medium focus:z-10 @sm:w-28",
              isActive ? "bg-sky-100 font-bold text-sky-700" : "text-zinc-500",
              tabIdx === 0 ? "rounded-l-lg" : "",
              tabIdx === trendFactors.length - 1 ? "rounded-r-lg" : ""
            )}
            aria-current={isActive ? "page" : undefined}
            onClick={() => {
              updateQuery({ name: "factor", value: factor.id });
            }}
          >
            <span>{factor.name}</span>
          </button>
        );
      })}
    </nav>
  );
};
